import {
	GET_CLIENT,
	GET_CLIENT_SUCCESS,
	GET_CLIENT_FAIL,
	SET_CLIENT_DASHBOARD,
	SEARCH_CLIENT,
	SEARCH_CLIENT_SUCCESS,
	SEARCH_CLIENT_FAIL,
	KICKOFF_CLIENT_API_REQUEST,
	KICKOFF_CLIENT_API_SUCCESS,
	KICKOFF_CLIENT_API_FAIL,
	CLIENT_DASH_DOWNLOAD,
	CLIENT_DASH_DOWNLOAD_SUCCESS,
	GET_CLIENT_MODALS,
	GET_CLIENT_MODALS_SUCCESS,
	GET_CLIENT_MODALS_FAIL
} from '../constants/clientConstants';
import { loadClientDashboardState } from '../utils/localStorageUtils';

/**
 * Reducer function for managing Client list state.
 *
 * This reducer handles actions related to fetching Client data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the Client list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const clientListReducer = (
	state = {
		loading: false,
		clientList: {},
		searchResult: {},
		searchLoading: false,
		searchError: '',
		kickOffClient: {
			apiLoading : false,
			apiData: {},
			apiError: null	
		}
	},
	action
) => {
	switch (action.type) {
		case GET_CLIENT:
			return {
				loading: true,
				clientList: {}
			};
		case GET_CLIENT_SUCCESS:
			return {
				loading: false,
				clientList: action.payload,
			};
		case GET_CLIENT_FAIL:
			return {
				loading: false,
				error: action.payload,
			};

		case SEARCH_CLIENT:
			return {
				...state,
				searchLoading: true,
			};
		case SEARCH_CLIENT_SUCCESS:
			return {
				...state,
				searchLoading: false,
				searchList: action.payload,
			};
		case SEARCH_CLIENT_FAIL:
			return {
				...state,
				searchLoading: false,
				searchError: action.payload,
			};
		case KICKOFF_CLIENT_API_REQUEST:
			return {
				...state,
				kickOffClient : {
					apiLoading : true,
					apiData: {},
					apiError: null
				}
			};
		case KICKOFF_CLIENT_API_SUCCESS:
			return {
				...state,
				kickOffClient : {
					apiLoading : false,
					apiData: action.payload,
					apiError: null
				}
			};
		case KICKOFF_CLIENT_API_FAIL:
			return {
				...state,
				kickOffClient : {
					apiLoading : false,
					apiData: {},
					apiError: action.payload
				}
			};
		default:
			return state;
	}
};

/**
 * Reducer function for managing Client dashboard state.
 *
 * This reducer handles actions related to fetching Client data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the Client dashboard.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const clientDashboardReducer = (
	state = { selectedClient: loadClientDashboardState() || {} },
	action
) => {
	switch (action.type) {
		case SET_CLIENT_DASHBOARD:
			return {
				...state,
				selectedClient: action.payload,
			};

		default:
			return state;
	}
};

export const clientDashDownloadReducer = (
	state = { clientDashDownload: false, showClientDownloadSuccessAlert:false },
	action
) => {
	switch (action.type) {
		case CLIENT_DASH_DOWNLOAD:
			return {
				...state,
				clientDashDownload: action.payload,
			};
		case CLIENT_DASH_DOWNLOAD_SUCCESS:
			return {
				...state,
				showClientDownloadSuccessAlert: action.payload,
			}
		default:
			return state;
	}
};

export const clientModalsReducer = (
	state = {
		loading: false,
		clientModalsList: {},
	},
	action
) => {
	switch (action.type) {
		case GET_CLIENT_MODALS:
			return {
				loading: true,
				clientModalsList: {}
			};
		case GET_CLIENT_MODALS_SUCCESS:
			return {
				loading: false,
				clientModalsList: action.payload,
			};
		case GET_CLIENT_MODALS_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};